'use strict';
angular.module('editingCenterLeftModule', ['ui.bootstrap', 'treeControl', 'editingCenterLeftDirModule']).controller('editingCenterNavController', [
    '$q',
    '$element',
    '$timeout',
    '$filter',
    '$state',
    '$scope',
    'trsHttpService',
    '$location',
    'modalDialog',
    'editingCenterService',
    'editingMediatype',
    'resourceCenterService',
    'messagePublishService',
    'iwoNoticeService',
    function (
        $q,
        $element,
        $timeout,
        $filter,
        $state,
        $scope,
        trsHttpService,
        $location,
        modalDialog,
        editingCenterService,
        editingMediatype,
        resourceCenterService,
        messagePublishService,
    ) {
        initStatus();
        initData();
        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.pathes = $location.path().split('/');
            $scope.currentSelected = $state;
            $scope.newspaperType = $state.current.name.split('.')[3];
            $scope.newspaperId = $location.search().paperid;
            $scope.doctype = $state.params.doctype;
            $scope.status = {
                oneKeyQuickSign: $scope.pathes[4] == "quicksign" ? true : false,
                fusionSignunReadCount: 0, // 融合审签未读消息数量
                fusionPendingunReadCount: 0, // 融合待编未读消息数量
                qunfaReadCount: 0, //微信已群发失败消息数量
                mediaType: {
                    '-1': 'iWo',
                    '1': 'app',
                    '2': 'website',
                    '3': 'newspaper',
                    '4': 'weixin',
                    '5': 'weibo',
                    '15': 'tv',
                    '16': 'broadcast',
                    '17': 'trill', // 抖音渠道（17是新编的）
                    '18': 'baijiahao', // 抖音渠道（18是新编的）
                    '19': 'qiehao', // 抖音渠道（19是新编的）
                    '20': 'toutiaohao',
                    '25': 'kuaishou', // 快手渠道
                },
                iwoNavData: {}, // iwo导航数据集合
                doLeftDir: false, // 开始渲染左侧导航
                rightsLibrary: {
                    JINRI: 'todaysDraft',
                    DAIYONG: 'standbyDraft',
                    SHANGBAN: 'pageDraft',
                    YIQIAN: 'signedDraft',
                    GUIDANG: 'archiveDraft',
                },
                newspaper: {
                    sites: [],
                    isDownPicShow: false, // 站点列表是否展开
                },
                order: ['newspaper', 'website', 'app', 'weixin', 'weibo', 'television', 'broadcast', 'douyin'], // APP：1，网站：2，报纸：3，微信：4，微博：5, 电视: 15, 广播: 7
                tab: {
                    app: {
                        isTabSelect: false,
                    },
                    website: {
                        isTabSelect: false,
                    },
                    iWo: {
                        isTabSelect: false,
                    },
                    newspaper: {
                        isTabSelect: false,
                    },
                    weixin: {
                        isTabSelect: false,
                    },
                    weibo: {
                        isTabSelect: false,
                    },
                    television: {
                        isTabSelect: false,
                    },
                    broadcast: {
                        isTabSelect: false,
                    },
                    trill: {
                        isTabSelect: false,
                    },
                    kuaishou: {
                        isTabSelect: false, // 新增快手渠道
                    },
                    baijiahao: {
                        isTabSelect: false,
                    },
                    qiehao: {
                        isTabSelect: false,
                    },
                    toutiaohao: {
                        isTabSelect: false,
                    },
                },
            };
            $scope.$root.narrowNavigation = true;
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            $q.all([
                (function () {
                    var deffer = $q.defer();
                    queryAllSites().then(function () {
                        initNewsPaperAuthority();
                        deffer.resolve();
                    });
                    return deffer.promise;
                })(),
                initNewspaper(),
                getIwoAuthority().then(function () {
                    if ($scope.status.iwoAuthority.FUSIONPENDING == 'true') {
                        fusionPendingUnReadMsg();
                    }
                    if ($scope.status.iwoAuthority.FUSIONSIGN == 'true') {
                        fusionSignUnReadMsg();
                    }
                }),
                wxQunFaUnReadMsg(),
                getUnReadMsg(),
                getAppSignedFail(),
            ]).then(function () {
                autoLocation();
                getDeptments();
                // 订阅一键快签是否显示
                messagePublishService.subscribe('refreshOneKeySigning', function (event, data) {
                    $scope.status.oneKeyQuickSign = data;
                },
                    $scope
                );
            });
        }

        /**
         * [autoLocation description] 订阅融合未读消息
         * @return {[type]} [description]
         */
        function getUnReadMsg() {
            messagePublishService.subscribe(
                'fusionSignGetUnReadMsg',
                function (event, data) {
                    $scope.status.fusionSignunReadCount = 0;
                    data.map((item) => {
                        if (item.MEDIATYPENAME === '全部' || item.MEDIATYPENAME === '纸媒') {
                            $scope.status.fusionSignunReadCount += Number(item.DOCCOUNT);
                        }
                    });
                    $scope.status.fusionSignunReadCount = $scope.status.fusionSignunReadCount > 999 ? '999+' : $scope.status.fusionSignunReadCount;
                },
                $scope);
            messagePublishService.subscribe(
                'fusionPendingGetUnReadMsg',
                function (event, data) {
                    $scope.status.fusionPendingunReadCount = 0;
                    data.map((item) => {
                        if (item.MEDIATYPENAME === '全部' || item.MEDIATYPENAME === '纸媒') {
                            $scope.status.fusionPendingunReadCount += Number(item.DOCCOUNT);
                        }
                    });
                    $scope.status.fusionPendingunReadCount = $scope.status.fusionPendingunReadCount > 999 ? '999+' : $scope.status.fusionPendingunReadCount;
                },
                $scope);
            messagePublishService.subscribe('wxQunFaCont', function (event, data) {
                $scope.status.qunfaReadCount = data.ALLCOUNT;
                $scope.status.qunfaReadCount = $scope.status.qunfaReadCount > 999 ? '999+' : $scope.status.qunfaReadCount;
            }, $scope);
        }

        function getUnReadNoticeCount(){
            messagePublishService.subscribe('unReadNoticeCountUpdate', function(event, data){
                $scope.status.noticeUnReadCount = data;
            }, $scope);
        }

        function getAppSignedFail(){
            messagePublishService.subscribe('getAppSignedFailNum', function(event, data){
                $scope.status.getAppSignedFailNum = data;
            }, $scope);
        }

        /**
         * [autoLocation description] 非精确定位时的自动定位
         * @return {[type]} [description]
         */
        function autoLocation() {
            $scope.status.doLeftDir = true; // 开始渲染左侧导航
            $timeout(() => {
                let router = $state.current.name;
                let routerArray = router.split('.');
                if (router !== 'front.editctr') {
                    if (
                        routerArray[2] == 'newspaper' ||
                        routerArray[3] == 'manuscriptCollection' ||
                        routerArray[3] == 'personalmaterial' ||
                        routerArray[3] == 'fusionPending' ||
                        routerArray[3] == 'fusionSign' ||
                        routerArray[3] == 'notice' ||
                        routerArray[3] == 'withdrawalmgt'
                    ) {
                        $scope.$root.narrowNavigation = true;
                    } else {
                        $scope.$root.narrowNavigation = false;
                    }
                    return;
                }
                try {
                    $element.find('.auto_location_parent')[0].click();
                    $element.find('.auto_location')[0].click();
                } catch (e) {
                }
            }, 600);
        }

        /**
         * [initNewsPaperAuthority description] 初始化报纸权限
         * @return {[type]} [description]
         */
        function initNewsPaperAuthority() {
            if (!$scope.status.authority.newspaper || $scope.status.authority.newspaper.SITES.length === 0) {
                return;
            }
            initNewsPaperPlatform(false);
        }

        /**
         * [initNewsPaperAuthority description] 初始化报纸平台
         * @param {[int]} paperId [纸媒ID]
         * @return {[type]} [description]
         */
        function initNewsPaperPlatform(paperId) {
            var deffered = $q.defer();
            var paperid = angular.isDefined($location.search().paperid)
                ? $location.search().paperid
                : $scope.status.authority.newspaper.SITES[0].SITEID;
            if (paperId) {
                paperid = $scope.newspaperId;
            }
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryCanOperOfPaper',
                Classify: 'paper',
                PaperSiteId: paperid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.newspapaerRight = data;
                deffered.resolve(data);
            });
            return deffered.promise;
        }

        /**
         * [newspaperClick description] 报纸 待编 待审 已签发
         * @param  {[type]} platform [description]
         * @return {[type]}          [description]
         */
        $scope.newspaperClick = function (platform) {
            $scope.status.selectedChannl = platform;
            $scope.$root.narrowNavigation = true;
            $scope.status.tab['newspaper'].isTabSelect = true;
            var param;
            if (platform === 'myshare') {
                param = {
                    siteid: $scope.status.newspaper.selectedSite.SITEID,
                    mediatype: 3,
                };
            } else {
                param = { paperid: $scope.status.newspaper.selectedSite.SITEID };
            }
            delete $scope.newspaperType;
            var timer = $timeout(function () {
                $scope.newspaperType = platform;
                $scope.newspaperId = $state.params.paperid;
                $state.go('front.editctr.newspaper.' + $scope.newspaperType, param, {
                    reload: 'front.editctr.newspaper.' + $scope.newspaperType,
                });
            }, 250);
            cancelTimer(timer);
        };

        /**
         * [trenchClick description] 渠道点击 （App、网站、微信、微博、抖音、快手、百家号、头条号、企鹅号）
         * @param   {[string]}  trench     [trench description] 渠道名
         * @param   {[string]}  auditType  [auditType description] 审核类型
         * @return  {[type]}               [return description]
         */
        $scope.trenchClick = function (trench, auditType) {
            routerToAuditTrench(trench, auditType);
        };

        /**
         * [routerToTrench description] 跳转到对应渠道（主要是用于待编、待审、已签发流程的渠道）
         * @param   {[string]}  trench     [trench description] 渠道名
         * @param   {[string]}  auditType  [platform description] 审核类型
         * @return  {[undefined]}          [return description]
         */
        function routerToAuditTrench(trench, auditType) {
            $scope.$root.narrowNavigation = false;
            $scope.status.tab[trench].isTabSelect = true;
            $scope[trench + 'PlatForm'] = auditType;
            let curRouter = $state.current.name;
            let willRouter = 'front.editctr.' + trench + '.' + auditType;
            if (curRouter !== willRouter) {
                $state.go('front.editctr.' + trench, '', {
                    reload: 'front.editctr.' + trench,
                });
            }
        }


        /**
         * [televisionClick 电视渠道点击事件] 广电文稿 串联单切换
         * @param  {[type]} doctype [description]
         * @return {[type]}          [description]
         */
        $scope.televisionClick = function (doctype) {
            $scope.$root.narrowNavigation = false;
            $scope.status.tab['television'].isTabSelect = true;
            var curRouter = $state.current.name;
            var curDoctype = $state.params.doctype;
            var path = $location.path().split('/');
            var platform;
            $scope.televisionDoctype = doctype;
            if (curRouter.indexOf('front.editctr.television') >= 0 && !!path[4]) {
                $scope.televisionSiteId = $state.params.siteid;
                $scope.televisionDoctype = $state.params.doctype;
                platform = path[4];
            }
            var willRouter = platform ? 'front.editctr.television.' + platform : 'front.editctr.television';
            if (curRouter !== willRouter || curDoctype !== doctype) {
                if (!platform) {
                    $state.go('front.editctr.television', { doctype: doctype });
                } else {
                    $state.go(willRouter, { doctype: doctype, siteid: $state.params.siteid }, { reload: willRouter });
                }
            }
        };

        /**
         * [broadcastClick 广播渠道点击事件] 广电文稿 串联单切换
         * @param  {[type]} doctype [description]
         * @return {[type]}          [description]
         */
        $scope.broadcastClick = function (doctype) {
            $scope.$root.narrowNavigation = false;
            $scope.status.tab['broadcast'].isTabSelect = true;
            var curRouter = $state.current.name;
            var curDoctype = $state.params.doctype;
            var path = $location.path().split('/');
            var platform;
            $scope.broadcastDoctype = doctype;
            if (curRouter.indexOf('front.editctr.broadcast') >= 0 && !!path[4]) {
                $scope.broadcastSiteId = $state.params.siteid;
                $scope.broadcastDoctype = $state.params.doctype;
                platform = path[4];
            }
            var willRouter = platform ? 'front.editctr.broadcast.' + platform : 'front.editctr.broadcast';
            if (curRouter !== willRouter || curDoctype !== doctype) {
                if (!platform) {
                    $state.go('front.editctr.broadcast', { doctype: doctype });
                } else {
                    $state.go(willRouter, { doctype: doctype, siteid: $state.params.siteid }, { reload: willRouter });
                }
            }
        };

        /**
         * [newspaperClickFirst description] 报纸自动点击第一个平台
         * @return {[type]} [description]
         */
        $scope.newspaperClickFirst = function () {
            $element.find('.sidebar_content_pan').removeClass('menu_start');
            $element.find('[ld-targetPanel=\'4\']').hide();
            var timer = $timeout(function () {
                $element
                    .find('.newspaperLevel2')
                    .find('li')[0]
                    .click();
            }, 500);
            cancelTimer(timer);
        };

        /**
         * [personalDraft description] 是否是个人采写子模块被选中
         * @return {[type]} [description]
         */
        $scope.personalDraft = function () {
            let path = $scope.pathes[4];
            if (
                path == 'personalManuscript' ||
                path == 'receivedManuscript' ||
                path == 'newspaperAwaitRevise' ||
                path == 'manuscriptArchives' ||
                path == 'draftBox' ||
                path == 'myShare'
            ) {
                return true;
            } else {
                return false;
            }
        };

        /**
         * [personalDraftHasRight description] 个人采写模块是否有权限
         * @return {[type]} [description]
         */
        $scope.personalDraftHasRight = function () {
            return (
                $scope.status.iwoAuthority.PERSONALMANUSCRIPT == 'true' ||
                $scope.status.iwoAuthority.RECEIVEDMANUSCRIPT == 'true' ||
                $scope.status.iwoAuthority.IWOXIUDING == 'true' ||
                $scope.status.iwoAuthority.MANUSCRIPTARCHIVES == 'true' ||
                $scope.status.iwoAuthority.DRAFTBOX == 'true' ||
                $scope.status.iwoAuthority.SHAREDOCMANAGE == 'true'
            );
        };

        /**
         * [toPersonDraft description] 进入个人采写
         * @return {[type]} [description]
         */
        $scope.toPersonDraft = function () {
            if ($state.current.name.indexOf('iWo') < 0) {
                $state.go('front.editctr.iWo', {}, { reload: false });
            }
            if (!$scope.personalDraftHasRight()) {
                $scope.$root.narrowNavigation = true;
                return;
            }
            $scope.$root.narrowNavigation = false;
            $scope.status.iwoType = 'personDraft';
        };

        /**
         * [toDepartmentManuscript description] 进入部门稿库
         * @return {[type]} [description]
         */
        $scope.toDepartmentManuscript = function () {
            $scope.status.iwoType = 'departmentManuscript';
            if ($state.current.name.indexOf('iWo') < 0) {
                $state.go('front.editctr.iWo', {}, { reload: false });
            }
            if ($scope.status.iwoNavData.departMentList && $scope.status.iwoNavData.departMentList.length > 0) {
                $scope.$root.narrowNavigation = false;
                return;
            }
            getDeptments().then(function () {
                if ($scope.status.iwoNavData.departMentList && $scope.status.iwoNavData.departMentList.length > 0) {
                    $scope.$root.narrowNavigation = false;
                } else {
                    $scope.$root.narrowNavigation = true;
                }
            });
        };

        /**
         * [getDeptments description]获得部门稿库单位
         * @return {[type]} [description]
         */
        function getDeptments() {
            var defer = $q.defer();
            if ($scope.status.iwoNavData.departMentList) {
                defer.resolve();
            }
            var params = {
                serviceid: 'mlf_departoperdoc',
                methodname: 'queryDeptmentalDocs',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.iwoNavData.departMentList = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [toCustom description] 进入常用订阅
         * @return {[type]} [description]
         */
        $scope.toCustom = function () {
            $scope.status.iwoType = 'custom';
            if ($state.current.name.indexOf('iWo') < 0) {
                $state.go('front.editctr.iWo', {}, { reload: false });
            }
            if ($scope.status.iwoNavData.customList && $scope.status.iwoNavData.customList.length > 0) {
                $scope.$root.narrowNavigation = false;
                var item = $scope.status.iwoNavData.customList[0];
                $state.go('front.editctr.iWo.custom', {
                    customid: item.CUSTOMID,
                    customtype: item.CUSTOMTYPE,
                    mycustomid: item.MYCUSTOMID,
                    isugc: item.ISUGC,
                });
                return;
            }
            let params = {
                serviceid: 'mlf_releasesource',
                methodname: 'queryMyCustoms',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.iwoNavData.customList = data.DATA;
                var item = $scope.status.iwoNavData.customList[0];
                if ($scope.status.iwoNavData.customList && $scope.status.iwoNavData.customList.length > 0) {
                    $scope.$root.narrowNavigation = false;
                    $state.go('front.editctr.iWo.custom', {
                        customid: item.CUSTOMID,
                        customtype: item.CUSTOMTYPE,
                        mycustomid: item.MYCUSTOMID,
                        isugc: item.ISUGC,
                    });
                } else {
                    $scope.$root.narrowNavigation = true;
                    modalDialog.alertType(
                        '',
                        '您还没有添加常用订阅，是否去添加？',
                        'ask',
                        true,
                        function () {
                            $state.go('front.networksource', {}, { reload: true });
                        },
                        function () {
                            $state.go('front.editctr.iWo.personalManuscript', {}, { reload: true });
                        },
                        2000,
                        '取消',
                        '确认',
                    );
                }
            });
        };

        /**
         * [toPersonalMaterial description] 进入个人素材
         * @return {[type]} [description]
         */
        $scope.toPersonalMaterial = function () {
            let params = {
                resourcetype: '2',
                parentfcode: 'navigation_007001',
            };
            messagePublishService.publish('changeTopModule', 'resourcectrl');
            resourceCenterService.go('front.resourcectrl.material.personal', params);
        };

        /**
         * [toManuscriptCollection description] 进入稿件收藏
         * @return {[type]} [description]
         */
        $scope.toManuscriptCollection = function () {
            $scope.status.iwoType = 'manuscriptCollection';
            $state.go('front.editctr.iWo.manuscriptCollection', '', {
                reload: 'front.editctr.iWo.manuscriptCollection',
            });
            $scope.$root.narrowNavigation = true;
        };

        /**
         * [toFusionPending description] 进入融合待编
         * @return {[type]} [description]
         */
        $scope.toFusionPending = function () {
            $scope.status.iwoType = 'fusionPending';
            $state.go('front.editctr.iWo.fusionPending', '', {
                reload: 'front.editctr.iWo.fusionPending',
            });
            $scope.$root.narrowNavigation = true;
        };

        /**
         * [toFusionSign description] 进入融合审签
         * @return {[type]} [description]
         */
        $scope.toFusionSign = function () {
            $scope.status.iwoType = 'fusionSign';
            $state.go('front.editctr.iWo.fusionSign', '', {
                reload: 'front.editctr.iWo.fusionSign',
            });
            $scope.$root.narrowNavigation = true;
        };

        /**
         * [toFusionSign description] 进入通知公告
         * @return {[type]} [description]
         */
        $scope.toNotice = function () {
            $scope.status.iwoType = 'notice';
            $state.go('front.editctr.iWo.notice', {}, { reload: 'front.editctr.iWo.notice' });
            $scope.$root.narrowNavigation = true;
        };

        /**
         * [toWithdrawalMgt description] 进入撤稿指令管理
         * @return {[type]} [description]
         */
        $scope.toWithdrawalMgt = function () {
            $scope.status.iwoType = 'withdrawalmgt';
            $state.go('front.editctr.iWo.withdrawalmgt', '', {
                reload: 'front.editctr.iWo.withdrawalmgt',
            });
            $scope.$root.narrowNavigation = true;
        };

        $scope.toIssueManuscript = function () {
            $scope.status.iwoType = 'issueManuscript';
            $state.go('front.editctr.iWo.issueManuscript', '', {
                reload: 'front.editctr.iWo.issueManuscript',
            });
            $scope.$root.narrowNavigation = true;
        };


        /**
         * [queryAllSites 查询可见产品]
         *
         * @return  {[type]}
         *   [return description]
         */
        function queryAllSites() {
            var deffered = $q.defer();
            var params = {
                serviceid: 'mlf_mediasite',
                methodname: 'queryAllSites',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.status.authority = {};
                angular.forEach(data, function (_data) {
                    $scope.status.authority[$scope.status.mediaType[_data.MEDIATYPE]] = _data;
                });
                // 给对象排序
                var i = 0;
                angular.forEach($scope.status.order, function (__data, __index, __array) {
                    if (angular.isDefined($scope.status.authority[__data])) {
                        $scope.status.authority[__data].index = i;
                        i++;
                    }
                });
                deffered.resolve();
            });
            return deffered.promise;
        }

        /**
         * [getIwoAccessAuthority description]获取IWO的访问权限
         * @return {[type]} [description] promise
         */
        function getIwoAuthority() {
            var params = {
                serviceid: 'mlf_metadataright',
                methodname: 'queryCanOperIWOModals',
                classify: 'iwo',
            };
            var defer = $q.defer();
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.status.iwoAuthority = data;
                var flag = false;
                for (var i in $scope.status.iwoAuthority) {
                    if ($scope.status.iwoAuthority[i] === 'true') {
                        flag = true;
                        break;
                    }
                }
                $scope.status.iwoHasAuthority = flag; // 查看是否iwo有权限，从而来判断是否隐藏iwo入口
                // 默认跳转页为iwo的个人稿库，此处查看默认跳转页是否有权限，用来判断右侧列表是否显示出来
                if (angular.isDefined($scope.$root.status)) {
                    $scope.$root.status.defaultListRight = $scope.status.iwoAuthority.PERSONALMANUSCRIPT === 'true';
                } else {
                    $scope.$root.status = {
                        defaultListRight: $scope.status.iwoAuthority.PERSONALMANUSCRIPT === 'true',
                    };
                }
                defer.resolve();
            });
            return defer.promise;
        }

        $scope.dropDownBtn = function () {
            $scope.$root.narrowNavigation = true;
            $scope.status.isdownPicShow = !$scope.status.isdownPicShow;
        };
        $scope.newspaperSelect = function (site) {
            $scope.status.isdownPicShow = !$scope.status.isdownPicShow;
            if ($scope.status.newspaper.selectedSite === site) {
                return;
            }
            $scope.status.newspaper.selectedSite = site;
            $scope.newspaperId = site.SITEID;
            initNewsPaperPlatform(site.SITEID).then(function (rights) {
                var timer = $timeout(function () {
                    var isHaveChannel = false;
                    var curRouterName = $state.current.name.split('.')[3];
                    var liChildren = $element.find('.newspaperLevel2').find('li');
                    var toNewspaperChanne;
                    liChildren.each((li) => {
                        if (liChildren[li].getAttribute('routerName') == curRouterName) {
                            isHaveChannel = true;
                        } else {
                            isHaveChannel = false;
                        }
                        if (isHaveChannel) {
                            return false;
                        }
                    });
                    if (isHaveChannel) {
                        toNewspaperChanne = curRouterName;
                    } else {
                        toNewspaperChanne = liChildren[1].getAttribute('routerName');
                    }

                    $scope.newspaperClick(toNewspaperChanne);
                });
                cancelTimer(timer);
            });
        };
        $scope.$on('newspaperDropDown', function (event, data) {
            $scope.status.isdownPicShow = false;
        });


        /**
         * [initNewspaper 初始化报纸]
         *
         * @return  {[type]}
         *   [return description]
         */
        function initNewspaper() {
            var defer = $q.defer();
            editingCenterService.querySitesByMediaType(editingMediatype.newspaper).then(function (data) {
                if (!data || !data.DATA) {
                    defer.resolve();
                } else {
                    $scope.status.newspaper.sites = data.DATA;
                    $scope.status.newspaper.isDownImgShow = data.DATA.length > 1;
                    var filteredSite = $filter('filterBy')(data.DATA, ['SITEID'], $scope.newspaperId);
                    $scope.status.newspaper.selectedSite = filteredSite.length > 0 ? filteredSite[0] : data.DATA[0];
                    defer.resolve();
                }
            });
            var newspaperDropdownBlur = function (event) {
                var theTarget = $element.find('.newspaperDropdown')[0];
                var $target = $(event.target);
                if ($target.parents('.newspaperDropdown')[0] !== theTarget) {
                    $scope.status.isdownPicShow = false;
                }
            };
            window.addEventListener('mousedown', newspaperDropdownBlur);
            $scope.$on('$destroy', function () {
                window.removeEventListener('mousedown', newspaperDropdownBlur);
            });
            return defer.promise;
        }

        /**
         * [cancelTimer description] 当控制器被销毁时，立即停止timer里的内容继续执行
         * @param {promise} [timer] [description] 定时器
         * @return {[type]} [description]
         */
        function cancelTimer(timer) {
            $scope.$on('$destroy', function () {
                $timeout.cancel(timer);
            });
        }

        /**
         * [unReadMsg description]查询融合审签未读消息
         *
         * @return  {[type]}  [return description]
         */
        function fusionSignUnReadMsg() {
            var params = {
                ServiceId: 'mlf_fusion',
                OprTime: '',
                Methodname: 'queryFusionDocumentsCountInShenQian',
                OprTimeStart: '',
                OprTimeEnd: '',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                messagePublishService.publish('fusionSignGetUnReadMsg', data);
            });
        }

        /**
         * [unReadMsg description]查询融合待编未读消息
         *
         * @return  {[type]}  [return description]
         */
        function fusionPendingUnReadMsg() {
            var params = {
                ServiceId: 'mlf_fusion',
                OprTime: '',
                Methodname: 'queryFusionDocumentsCountInDaiBian',
                OprTimeStart: '',
                OprTimeEnd: '',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                messagePublishService.publish('fusionPendingGetUnReadMsg', data);
            });
        }

        /**
         * [wxQunFaUnReadMsg description] 微信群发失败未读消息
         *
         * @return  {[type]}  [return description]
         */
        function wxQunFaUnReadMsg() {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'getSendCardFailedCount',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                messagePublishService.publish('wxQunFaCont', data);
            });
        }

    },
]).factory('forFusionSign', [
    'trsHttpService',
    'messagePublishService',
    '$state',
    '$timeout',
    function (trsHttpService, messagePublishService, $state, $timeout) {
        return {

            /**
             * [unReadMsg description]查询融合审签未读消息并绑定栏目
             *
             * @return  {[type]}  [return description]
             */
            getCountAndBindType: function (typeArr) {
                var params = {
                    ServiceId: 'mlf_fusion',
                    OprTime: '',
                    OprTimeStart: '',
                    OprTimeEnd: '',
                };
                var actionName = '';
                if ($state.current.url === '/fusionSign') {
                    params.Methodname = 'queryFusionDocumentsCountInShenQian';
                    actionName = 'fusionSignGetUnReadMsg';
                }
                if ($state.current.url === '/fusionPending') {
                    params.Methodname = 'queryFusionDocumentsCountInDaiBian';
                    actionName = 'fusionPendingGetUnReadMsg';
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    var obj = data.reduce((cur, next) => {
                        cur[next.MEDIATYPE] = next.DOCCOUNT;
                        return cur;
                    }, {});
                    typeArr.forEach((item) => {
                        item.DOCCOUNT = obj[item.MEDIATYPE];
                    });
                    messagePublishService.publish(actionName, data);
                    $timeout(() => typeArr);
                });
            },
            getwxQunfaCont: function () {
                var params = {
                    serviceid: 'mlf_wechatgroupsend',
                    methodname: 'getSendCardFailedCount',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    messagePublishService.publish('wxQunFaCont', data);
                    messagePublishService.publish('wxLeftFaCont', data);
                });
            },
        };
    },
]);
